<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex pb-6>
        <Level1 v-if="level == '0'" @stepper="winStepper" />
        <Level2 v-if="level == '1'" @stepper="winStepper" />
        <Level3 v-if="level == '2'" @stepper="winStepper" />
        <Level4 v-if="level == '3'" @stepper="winStepper" />
        <Level5 v-if="level == '4'" @stepper="winStepper" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Level1 from "./level1";
import Level2 from "./level2";
import Level3 from "./level3";
import Level4 from "./level4";
import Level5 from "./level5";

export default {
  components: {
    Level1,
    Level2,
    Level3,
    Level4,
    Level5,
  },
  data() {
    return {
      level: 0,
    };
  },
  computed: {
    applevel() {
      return this.getProfile();
    },
  },

  mounted() {
    this.getLevl();
    this.getProfile();
  },
  methods: {
    winStepper(window_data) {
      this.level = window_data.level;
      // console.log("stepper initialized", this.level);
    },

    getLevl() {
      this.level = this.$store.state.level;
      // console.log("level", this.level);
    },
    getProfile() {
      axios({
        method: "post",
        url: "user/me",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.level = response.data.level;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
